/**
 * @file
 * Theme javascript.
 */
(function ($) {
"use strict";

  const directionRtl = $('html')[0].dir === 'rtl' ? true : false;

  Drupal.behaviors.navBurger = {
    attach: function (context, settings) {
      const $html = $('html');
      const $header = $('body > div > header');
      const $burger = $header.find('.region-header > .burger-menu > .burger');

      $burger.next().wrap('<div class="burger-nav"></div>');
      $('.burger-nav').prepend('<div class="header_navburger-overlay"></div>');

      $header.after('<div class="header_navburger"></div>');
      $('.header_navburger').append($('.burger-nav').html());

      $burger.on('click', function () {
        const isActive = $(this).attr('menu-burger') === 'true';
        $(this).attr('menu-burger', !isActive);
        $html.attr('menu-burger', !isActive);
      });

      $('.header_navburger-overlay').on('click', function () {
        $burger.attr('menu-burger', false);
        $html.attr('menu-burger', false);
      });

      const $menuItem = $('.header_navburger .menu > .menu-item--expanded .menu-title');

      $menuItem.on('click', function (e) {
        const parent = $(this).parent();
        const isActive = parent.attr('sous-menu') === 'true';
        parent.attr('sous-menu', !isActive);

        if (parent.attr('sous-menu') === 'true') {
          parent.children('.menu_link_content').slideDown();
        } else {
          parent.children('.menu_link_content').slideUp();

          const children = parent.find('.menu-item--expanded');
          children.attr('sous-menu', 'false').children('.menu_link_content').slideUp();
        }
      });
    }
  };

  Drupal.behaviors.navHorizontale = {
    attach: function (context, settings) {
      const $menuItem = $('#block-web4umainmenublock .menu > .menu-item--expanded .menu-title');

      $menuItem.on('click', function (e) {
        const parent = $(this).parent();
        const siblings = parent.siblings('.menu-item--expanded');

        siblings.removeClass('-is-active');
        siblings.find('.menu-item--expanded').removeClass('-is-active');

        if (parent.hasClass('-is-active')) {
          parent.removeClass('-is-active');
          parent.find('.menu-item--expanded').removeClass('-is-active');
        } else {
          parent.addClass('-is-active');
        }
      });

      $('body').on('click', function (e) {
        const menu = $('#block-web4umainmenublock > div > .menu');

        if ($(window).width() <= 1023 || !$('> .menu-item--expanded.-is-active', menu).length) {
          return;
        }

        if (!$(e.target).closest(menu).length) {
          $('#block-web4umainmenublock .menu > .menu-item--expanded').removeClass('-is-active');
        }

      });
    }
  };

  Drupal.behaviors.headerItemLength = {
    attach: function (context, settings) {
      const $header = $('body > div > header', context);
      const $menu = $header.find('.menu-level-0');

      $(once('headerItemLength', $menu, context)).each( function() {
        if ($(this).children().length <= 5) {
          $(this).addClass('menu-small');
        }
      });

    }
  };

  Drupal.behaviors.commonExternalLink = {
    attach: function (context, settings) {
      $('a', context).each(function () {
        let href = this.href;
        if (href === '#') {
          return;
        }

        let match = href.match(/^.*\.([a-z0-9]+)$/i);
        if (match != null) {
          $(this).attr('target', '_blank').attr('rel', 'noopener');
        }

        if (Drupal.url.isLocal(href) === true) {
          return;
        }

        // Les liens vers des domaines differents sont ouverts dans une
        // nouvelle fenêtre, sauf pour ceux ayant déjà un attribut target.
        if ($(this).attr('target') && $(this).attr('target') != '_blank') {
          $(this).attr('title', title.trim() + Drupal.t(' - open new window')).attr('rel', 'noopener');
          return;
        }

        $(this).attr('target', '_blank').attr('rel', 'noopener');
        let titre;
        titre = $(this).prop("innerText");
        $(this).attr('title', titre.trim() + Drupal.t(' - open in a new tab')).attr('rel', 'noopener');
        $(this).addClass('external-website');

      });
    }
  };

  Drupal.behaviors.footerAccordeonMobile = {
    attach: function (context, settings) {
      const $col = $('footer .wrapper-content').children();
      const desktopWidth = 1024;

      $col.each(function () {
        const $title = $(this).find('.item-list .title');

        $title.on('click', function () {
          if ($(window).width() < desktopWidth) {
            $(this).toggleClass('active');
            $(this).next().slideToggle();
          }
        });
      });
    }
  };

  Drupal.behaviors.storeLocatorAccordeon = {
    attach: function (context, settings) {
      const $page = $('.path-store-locator .store-locator', context);
      const $region = $page.find('.wrapper-region');
      const desktopWidth = 1024;

      $region.each(function () {
        const $title = $(this).children('.region-title');

        $title.on('click', function () {
          if ($(window).width() < desktopWidth) {
            $(this).toggleClass('active');
            $(this).next().slideToggle();
          }
        });
      });
    }
  };

  Drupal.behaviors.carrousel = {
    attach: function (context, settings) {
      $(once('carrousel', '.paragraph--type--carrousel', context)).each(function () {
        const $slider = $(this).children('.field--name-field-carousel-items');
        const settings = {
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          rtl: directionRtl,
          responsive: [
            {
              breakpoint: 1440,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 725,
              settings: {
                slidesToShow: 1.05,
                arrows: false,
                dots: true,
              }
            }
          ]
        };
        const sl =  $slider.slick(settings);

        $(window).on('resize', function() {
          if( $(window).width() > 725 &&  !sl.hasClass('slick-initialized')) {
            $slider.slick(settings);
          }
        });
      });
    }
  };

  Drupal.behaviors.photoGallery = {
    attach: function (context, settings) {
      let $gallery = $('.paragraph--type--photo-gallery', context);

      $(once('photoGallery', $gallery, context)).each(function () {
        const $slider = $(this).children('.field--name-field-pictures');

        $slider.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          arrows: true,
          dots: false,
          rtl: directionRtl,
        });
      });

    }
  };

  Drupal.behaviors.sliders = {
    attach: function (context, settings) {
      // * Where do we need mobile slider for partners
      let $newContent = $('.wrapper-slider:not(.wrapper-partners-grid)', context);
      $newContent.each(
        function () {
          // let $blocPartners = $newContent.find('.wrapper-partners');
          // if($blocPartners.length > 0) {
          if($newContent.length > 0) {
            Drupal.behaviors.sliders.initializeSlider($newContent);
          }
        }
      );
    },

    initializeSlider: function (context, settings) {
      let $sliderWrapper = $(context);

      $sliderWrapper.each(function () {
        const $slider = $(this).children('.slider-content').not('.slick-initialized');

        $slider.slick({
          infinite: true,
          slidesToShow: 6,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          rtl: directionRtl,
          responsive: [
            {
              breakpoint: 1440,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 725,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
      });
    }
  };

  Drupal.behaviors.pageTyreHeader = {
    attach: function (context) {
      let $headerRight = $('.page-node-type-tyre .wrapper-header-right', context);
      let $wrapperPictos = $('.page-node-type-tyre .wrapper-header-left .wrapper-pictos', context);

      // * set max height style for mobile screens only
      const mediaQueryList = window.matchMedia('(max-width: 1023px)');

      function handleWidthChange(mediaQueryList) {
        if (mediaQueryList.matches) {
          // * get the values set by mediaQuery
          let margin = $wrapperPictos.css('margin-top');

          // * calculate wrapper height and adjust position based on margins -> converted to rem
          let maxHeight = Math.round(($wrapperPictos.outerHeight(true) - (parseInt(margin) / 2) + 16) / 16);
          // * set max height
          $headerRight.css('max-height', `calc(100% - ${maxHeight}rem)`);
        }
        else if (!mediaQueryList.matches) {
          $headerRight.css('max-height', 'unset');
        }
      }

        handleWidthChange(mediaQueryList);
        mediaQueryList.addEventListener('change', handleWidthChange);
    },
  };

  Drupal.behaviors.appointmentNextButtonDate = {
    attach(context) {
      $(once('bookAnAppointmentMap', '.path-book-appointment .form-item-field-appointment-date'), context).each(function() {
        const morningRadio = $('#edit-field-appointment-period-morning', context);
        const afternoonRadio = $('#edit-field-appointment-period-afternoon', context);

        const checkDateFormFilling = function () {
          if ($(this).find('#edit-field-appointment-date').val() !== '' && (morningRadio.is(':checked') || afternoonRadio.is(':checked'))) {
            $('.next-step-submit.button').prop('disabled', false);
            $('.wrapper-next-step').removeClass('-input-disabled');
          } else {
            $('.next-step-submit.button').prop('disabled', true);
            $('.wrapper-next-step').addClass('-input-disabled');
          }
        };

        $(window).on('load', checkDateFormFilling);
        morningRadio.on('change', checkDateFormFilling);
        afternoonRadio.on('change', checkDateFormFilling);

      });
    },
  };

  Drupal.behaviors.appointmentNextButtonRadio = {
    attach(context) {
      $(once('appointmentNextButtonRadio', '#edit-radios'), context).each(function() {
        const smsRadioYes = $('#edit-field-contact-sms-1', context);
        const smsRadioNo = $('#edit-field-contact-sms-0', context);
        const emailRadioYes = $('#edit-field-contact-email-1', context);
        const emailRadioNo = $('#edit-field-contact-email-0', context);

        const checkRadioButton = function () {
          if(smsRadioYes.hasClass( "error" ) || smsRadioNo.hasClass( "error" )) {
            $('#edit-field-contact-sms').find('label').addClass('-input-error');
          }

          if (emailRadioYes.hasClass( "error" ) || emailRadioNo.hasClass( "error")) {
            $('#edit-field-contact-email').find('label').addClass('-input-error');
          }

          if(smsRadioYes.is(':checked') || smsRadioNo.is(':checked')) {
            $('#edit-field-contact-sms').find('label').removeClass('-input-error');
          }

          if(emailRadioYes.is(':checked') || emailRadioNo.is(':checked')) {
            $('#edit-field-contact-email').find('label').removeClass('-input-error');
          }
        };

        $(window).on('load', checkRadioButton);
        smsRadioYes.on('change', checkRadioButton);
        smsRadioNo.on('change', checkRadioButton);
        emailRadioYes.on('change', checkRadioButton);
        emailRadioNo.on('change', checkRadioButton);
      });
    },
  };

  Drupal.behaviors.pikaday = {
    attach: function (context) {
      const input = $('.pikaday:not(.inline)');
      const inputInline = $('.pikaday.inline');

      const morningRadio = $('#edit-field-appointment-period-morning', context);
      const afternoonRadio = $('#edit-field-appointment-period-afternoon', context);

      const checkDateFormFilling = function () {
        if ($('#edit-field-appointment-date', context).length === 0) return;
        if ($('#edit-field-appointment-date', context).val() !== '' && (morningRadio.is(':checked') || afternoonRadio.is(':checked'))) {
          $('.next-step-submit.button').prop('disabled', false);
          $('.wrapper-next-step').removeClass('-input-disabled');
        } else {
          $('.next-step-submit.button').prop('disabled', true);
          $('.wrapper-next-step').addClass('-input-disabled');
        }
      };

      let minimumDate = new Date();
      minimumDate.setDate(minimumDate.getDate() + 3);

      var picker = new Pikaday({
        field: input[0],
        firstDay: 1,
        minDate: minimumDate,
        disableDayFn: function(date) {
          if (date.getDay() === 0) {
            return date;
          }
        },
        format: 'YYYY-MM-DD',
        i18n: {
          months : [Drupal.t('January'),Drupal.t('February'),Drupal.t('March'),Drupal.t('April'),Drupal.t('May'),Drupal.t('June'),Drupal.t('July'),Drupal.t('August'),Drupal.t('September'),Drupal.t('October'),Drupal.t('November'),Drupal.t('December')],
          weekdays : [Drupal.t('Sunday'), Drupal.t('Monday'), Drupal.t('Tuesday'), Drupal.t('Wednesday'), Drupal.t('Thursday'), Drupal.t('Friday'), Drupal.t('Saturday')],
          weekdaysShort : [Drupal.t('Sun'),Drupal.t('Mon'),Drupal.t('Tue'),Drupal.t('Wed'),Drupal.t('Thu'),Drupal.t('Fri'),Drupal.t('Sat')]
        },
        onSelect: checkDateFormFilling,
      });

      var pickerInline = new Pikaday({
        field: inputInline[0],
        firstDay: 1,
        minDate: minimumDate,
        disableDayFn: function(date) {
          if (date.getDay() === 0) {
            return date;
          }
        },
        bound: false,
        format: 'YYYY-MM-DD',
        container: document.getElementById('container'),
        i18n: {
          months : [Drupal.t('January'),Drupal.t('February'),Drupal.t('March'),Drupal.t('April'),Drupal.t('May'),Drupal.t('June'),Drupal.t('July'),Drupal.t('August'),Drupal.t('September'),Drupal.t('October'),Drupal.t('November'),Drupal.t('December')],
          weekdays : [Drupal.t('Sunday'), Drupal.t('Monday'), Drupal.t('Tuesday'), Drupal.t('Wednesday'), Drupal.t('Thursday'), Drupal.t('Friday'), Drupal.t('Saturday')],
          weekdaysShort : [Drupal.t('Sun'),Drupal.t('Mon'),Drupal.t('Tue'),Drupal.t('Wed'),Drupal.t('Thu'),Drupal.t('Fri'),Drupal.t('Sat')]
        },
        onSelect: checkDateFormFilling,
      });

      $(window).on('load', checkDateFormFilling);
      morningRadio.on('change', checkDateFormFilling);
      afternoonRadio.on('change', checkDateFormFilling);
    },
  };

  Drupal.behaviors.textTranscript = {
    attach: function (context, settings) {
      let $btn = $('.media .button-transcription', context);

      $(once('textTranscript', $btn, context)).each(function () {
        const $popin = $(this).next('.transcription-texte');

        $(this).on('click', function() {
          $popin.fadeIn({
            duration: 300,
            start: function () {
              jQuery(this).css('display', 'flex');
            }
          });
        });

        $popin.on('click', function() {
          $(this).fadeOut();
        }).children().click(function() {
          return false;
        });

        const $close = $(this).next().find('.transcription-texte--close');

        $close.on('click', function() {
          $(this).parent().parent().fadeOut();
        });

      });

    }
  };

  Drupal.behaviors.partnersFilters = {
    attach(context) {
      $(once(
        'partnersFilters',
        '.wrapper-partners-grid',
        context
      )).each(function () {
        const $partnersBlock = $(this);
        const $partnersFilters = $('> .item-list .filters .partner-category', $partnersBlock);
        const $partnersElements = $('> .partners-content .taxonomy-term', $partnersBlock);

        // * set default show-all styles
        $partnersFilters.not('button[data-partner-category]').addClass('active-filter');

        const filterElements = function(category) {
          $partnersElements.each(function() {
            return !$(this).hasClass(`partner-category-${category}`) ? $(this).hide() : $(this).show();
          });
        };

        $partnersFilters.each(function() {
          $(this).click(function() {
            $partnersFilters.removeClass('active-filter');
            $(this).addClass('active-filter');

            let category = $(this).attr('data-partner-category');

            return category !== undefined ? filterElements(category) : $partnersElements.show();
          });
        });
      });
    },
  };

  Drupal.behaviors.languageSwitcher = {
    attach(context) {
      $(once(
        'languageSwitcher',
        '.block-web4u-commonlanguage-blocklanguage-interface',
        context
      )).each(function () {
        const $languageSwitcher = $(this);
        const $activeLanghuage = $('li.is-active', $languageSwitcher);
        const $languageList = $('ul', $languageSwitcher);
        const $languageOptions = $('li', $languageSwitcher);
        const $button = $('.language-switcher-button', $languageSwitcher);

        let buttonWidth = $(this).outerWidth();
        let listWidth = $languageList.outerWidth();
        if(listWidth > buttonWidth) {
          $(this).css('min-width', `${listWidth}px`);
        } else {
          $languageList.css('min-width', `${buttonWidth}px`);
        }

        $button.click(function () {
          $(this).toggleClass('active');
          $languageOptions.slideToggle(300);

          buttonWidth = $(this).outerWidth();
          listWidth = $languageList.outerWidth();

          if(listWidth > buttonWidth) {
            $(this).css('min-width', `${listWidth}px`);
          } else {
            if($(document).outerWidth() > 1024) {
              $languageList.css('min-width', `${buttonWidth}px`);
            }
          }

          $activeLanghuage.remove();
        });

      });
    },
  };

  Drupal.behaviors.bookAnAppointmentMap = {
    attach(context) {
      $(once('bookAnAppointmentMap', '.path-book-appointment .submit.same-page, .path-book-appointment .geolocalisation.same-page'), context).each(function(){
        $(this).on('click', function () {
          $('.store-locator-content').removeClass('-hidden');
        });
      });
      setTimeout(function(){
        let hidden_pos_id = $("#hidden_pos_id").val();
        if (hidden_pos_id != undefined) {
          $('.point_of_sale-' + hidden_pos_id).show();
        }
      }, 1000);
    },
  };

  Drupal.behaviors.backToTop = {
    attach(context) {
      once('backToTop', '.path-frontpage', context).forEach((page) => {
        const scrollSpy = document.createElement('span');
        scrollSpy.classList.add('scroll-spy');
        page.append(scrollSpy);
        const backToTopBtn = page.querySelector('.back-to-top-button');

        const obsCallback = function (entries) {
          if(entries[0].isIntersecting || scrollSpy.getBoundingClientRect().y < 0) {
            backToTopBtn.classList.add('-visible');
          } else {
            backToTopBtn.classList.remove('-visible');
          }
        };

        const observer = new IntersectionObserver(obsCallback);
        observer.observe(scrollSpy);
      });

      if ($('.path-frontpage #hp-first-section').html() === undefined) {
        $( ".hero-content" ).append('<div id="hp-first-section"></div>');
      }
    }
  };

  Drupal.behaviors.ongletsTyresoft = {
    attach: function (context) {
      $(once('ongletsTyresoft', '.tyresoft'), context).each(function () {

        const registrationsection = $(this).find('.tyresoft__registration');
        const sizesection = $(this).find('.tyresoft__size');
        const inputSelect = $(this).find('.tyresoft-size .form-select');
        const bgcolorValue = $(this).find('.tyresoft-registration-form').attr('data-bg-color');
        const inputRegistration = $(this).find('.tyresoft-registration-form__input');
        const tabRegistration = $(this).find('.tyresoft__onglets__registration');
        const tabSize = $(this).find('.tyresoft__onglets__size');

        const getBoxesSameHeight = () => {
          let highestBox = 0;
          $('.tyresoft__size, .tyresoft__registration').css({minHeight: 'auto'});
          $('.tyresoft__size, .tyresoft__registration').each(function() {
            if($(this).outerHeight() > highestBox){
              highestBox = $(this).outerHeight();
            }
          }).css({minHeight: highestBox});
        };

        getBoxesSameHeight();
        inputRegistration.css({background: bgcolorValue});

        $(window).on('resize', function(){
          if ($(this).width() >= 1023) {
            getBoxesSameHeight();
          }
          if ($(this).width() < 1023) {
            getBoxesSameHeight();
          }
        });

        $(inputSelect).on('click',function(e){
          $(this).parent().toggleClass('-opened');

          $(document).on('click', function(e) {
            if (!$(e.target).hasClass('form-select')) {
              $(this).parent().removeClass('-opened');
            }
          });
        });

        sizesection.hide();
        tabRegistration.addClass('-active');

        tabRegistration.on('click', function() {
          tabSize.removeClass('-active');
          $(this).addClass('-active');

          sizesection.hide();
          registrationsection.show();
        });

        tabSize.on('click', function() {
          tabRegistration.removeClass('-active');
          $(this).addClass('-active');

          registrationsection.hide();
          sizesection.show();
        });
      });
    }
  };

  Drupal.behaviors.immatSearchBackground = {
    attach: function (context) {
      $(once('immatSearchBackground', '.path-webshop, .path-book-appointment'), context).each(function (page) {

        const bgcolorValue = $(this).find('.wrapper-inner-car-info .immat-search').attr('data-bg-color');
        const inputRegistration = $(this).find('#immat-input');

        if (bgcolorValue) {
          inputRegistration.css({background: bgcolorValue});
        }
      });
    }
  };

  Drupal.behaviors.tyre_popin = {
    attach: function (context, settings) {
      let $detail_item = $('.detail-popin', context);
      let $link_detail = $('.type-popin__content__list .-link', context);
      let $link_back = $('.type-popin__header__nav__back', context);
      let $link_close = $('.type-popin__header__nav__close', context);
      $link_detail.on('click', function() {
        let $id_link = $(this).attr('data-details');
        $detail_item.addClass('-hide');
        $('.' + $id_link).removeClass('-hide');
        $(this).closest('.tyres-modal').addClass('-next');
      });
      $link_back.on('click', function() {
        $(this).closest('.tyres-modal').removeClass('-next');
        $detail_item.addClass('-hide');
      });
      $link_close.on('click', function() {
        $('.ui-dialog-titlebar-close').trigger('click');
      });

      $('body').on('click', function (e) {
        const $modal = $('.tyres-modal');

        if (!$modal.length) {
          return;
        }

        if (!$modal.is(e.target) && $modal.has(e.target).length === 0) {
          $('.ui-dialog-titlebar-close').trigger('click');
        }
      });
    }
  };

  // Drupal.behaviors.infoOnTyre = {
  //   attach: function (context, settings) {
  Drupal.behaviors.appointmentInfoTyre = {
    attach: function (context, settings) {
      $(once('appointmentInfoTyre', '.wrapper-inner-car-info'), context).each(function () {

        if($(this).hasClass('-yes-tyre-version')) {
          const widthSelect = $('#width-input');
          const heightSelect = $('#height-input');
          const diameterSelect = $('#diameter-input');
          const chargeSelect = $('#charge-input');
          const speedSelect = $('#speed-input');
          const nextStep = $('.next-step-submit.button');

          const tyreContainer = `<div class="pneu__container">
                                  <div class="pneu__container__width"></div>
                                  <div class="pneu__container__height"></div>
                                  <div class="pneu__container__diameter"></div>
                                  <div class="pneu__container__charge"></div>
                                  <div class="pneu__container__speed"></div>
                                </div>`;

          $(this)[0].insertAdjacentHTML('beforeEnd', tyreContainer);

          const pneuWidth = $('.pneu__container__width');
          const pneuHeight = $('.pneu__container__height');
          const pneuDiameter = $('.pneu__container__diameter');
          const pneuCharge = $('.pneu__container__charge');
          const pneuSpeed = $('.pneu__container__speed');

          if(widthSelect.val() !== '0') {
            pneuWidth.html(widthSelect.val());
          }

          if(heightSelect.val() !== '0') {
            pneuHeight.html(heightSelect.val());
            pneuWidth.after('<div id="pneu-separator" class="pneu__container__separator">/</div>');
          }

          if(diameterSelect.val() !== '0') {
            pneuDiameter.html('R' + diameterSelect.val());
          }

          if(chargeSelect.val() !== '0') {
            pneuCharge.html(chargeSelect.val());
          }

          if(speedSelect.val() !== '0') {
            pneuSpeed.html(speedSelect.val());
          }

          const disableLink = (widthValue, heightValue, diameterValue, link) => {

            if (widthValue === '0' || heightValue === '0' || diameterValue === '0') {
              link[0].disabled = true;
              return;
            }

            if (widthValue !== '' && heightValue !== '' && diameterValue !== '') {
              link[0].disabled = false;
            } else {
              link[0].disabled = true;
            }
          };

          widthSelect.on('change', function() {
            let width = $(this).val();
            let height = heightSelect.val();
            let diameter = diameterSelect.val();

            disableLink(width, height, diameter, nextStep);

            if(width === 0) {
              $('#tyresoft-pneu-separator').remove();
            }

            if (width === '0' || width === '') {
              pneuWidth.html('');
              return;
            }

            pneuWidth.html(width);
          });

          heightSelect.on('change', function() {
            let width = widthSelect.val();
            let height = $(this).val();
            let diameter = diameterSelect.val();

            disableLink(width, height, diameter, nextStep);

            let separator = '<div id="pneu-separator" class="pneu__container__separator">/</div>';

            if(height === '0') {
              $('#pneu-separator').remove();
            } else {
              pneuWidth.after(separator);
            }

            if (height === '0') {
              pneuHeight.html('');
              return;
            }

            pneuHeight.html(height);
          });

          diameterSelect.on('change', function() {
            let width = widthSelect.val();
            let height = heightSelect.val();
            let diameter = $(this).val();

            disableLink(width, height, diameter, nextStep);

            if (width ==='0' || height ==='0' || diameter === '0') {
              pneuDiameter.html('');
              return;
            }

            if (diameter === '') {
              pneuDiameter.html('');
            }

            pneuDiameter.html('R' + diameter);
          });

          chargeSelect.on('change', function() {
            let charge = $(this).val();

            if (charge === '0') {
              pneuCharge.html('');
              return;
            }

            pneuCharge.html(charge);
          });

          speedSelect.on('change', function() {
            let speed = $(this).val();

            if (speed === '0') {
              pneuSpeed.html('');
              return;
            }

            pneuSpeed.html(speed);
          });
        }
      });
    }
  };

  Drupal.behaviors.hpPromotionSlider = {
    attach(context) {
      once('hpPromotionSlider', '.path-frontpage .promotion .field--name-field-promotions', context).forEach((promotionBlock) => {
        const promotionSlides = promotionBlock.querySelectorAll('.promotion__slide');

        if (promotionSlides.length < 2) return;

        $(promotionBlock).slick({
          rows: 0,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: false,
          dots: true,
        });
      });
    }
  };
})(jQuery);
